export default __webpack_public_path__ + "static/media/wine@2x.903e9256.png";